import { render, staticRenderFns } from "./selling-product.vue?vue&type=template&id=62c1b54a"
import script from "./selling-product.vue?vue&type=script&lang=js"
export * from "./selling-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports